export const stripURL = (url: string): string =>
  url.replace(/[[0-9a-f-]{36}/g, ':id');
